document.addEventListener('DOMContentLoaded', () => {
  // 1. Select all radio inputs
  const variantRadios = document.querySelectorAll('.js-option');
  const subtitleElement = document.getElementById('product-subtitle');

  // 2. On page load, find the currently checked radio (if any) and set the subtitle
  variantRadios.forEach((radio) => {
    if (radio.checked) {
      subtitleElement.textContent = radio.value;
    }
  });

  // 3. Listen for "change" events to update subtitle whenever a user picks a new variant
  variantRadios.forEach((radio) => {
    radio.addEventListener('change', (event) => {
      subtitleElement.textContent = event.target.value;
    });
  });
});
